import React, { Fragment } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useLocation,Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import PrivacyPolicyModal from "../../components/common/privacyPolicy";

function Footer() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    navigate(`#${id}`, { replace: false });
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Fragment>
      {/* Footer */}
      <footer className="footer">
        <div className="footer-top px-3">
          <Container>
            <Row>
              <Col md={4}>
                <div className="footer-column footer-about">
                  <h3 className="footer-title">About GP Homes</h3>
                  <p className="footer-about-text">
                    At GP Homes, our legacy is built on trust, quality, and
                    timely delivery. With over 2000 happy families residing in
                    200+ thoughtfully crafted homes, we have consistently upheld
                    our promise of on-time handovers, solidifying our reputation
                    as one of Chennai’s leading real estate developers.
                  </p>
                </div>
              </Col>
              <Col md={3} className="offset-md-1">
                <div className="footer-column footer-explore clearfix">
                  <h3 className="footer-title">Explore</h3>
                  <div className="d-flex  gap-5">
                    <ul className="footer-explore-list list-unstyled mb-1 p-0">
                      <li><a className="fs-6" onClick={() => scrollToSection("home")}>Home</a></li>
                      <li><a className="fs-6" onClick={() => scrollToSection("About-Us")}>About</a></li>
                      <li><a className="fs-6" onClick={() => scrollToSection("Configuration")}>Configuration</a></li>
                      <li> <a className="fs-6" onClick={() => scrollToSection("Overview")}>Overview</a></li>
                      <li><a className="fs-6" onClick={() => scrollToSection("Amenities")}>Amenities</a></li>
                      <li> <a className="fs-6" onClick={() => scrollToSection("Contact")}>Contact</a></li>
                     <li>
      <Link
        to="/privacy"
        state={{ backgroundLocation: location }}
        className="fs-6"
      >
        Privacy Policy
      </Link>
    </li>
                    </ul>
                  </div>
                </div>
              </Col>
              <Col md={4}>
                <div className="footer-column footer-contact">
                  <h3 className="footer-title">Contact</h3>
                  <p className="footer-contact-text">
                    W-820, 9th St, Syndicate Colony,
                    <br />
                    D-Sector, Anna Nagar West Extension,
                    <br />
                    Chennai, Tamil Nadu 600101
                  </p>
                  <div className="footer-contact-info">
                    <p className="footer-contact-phone">
                      <span className="flaticon-call"></span>{" "}
                      <a href="tel:+919344481444">9344481444</a>
                    </p>
                    <p className="footer-contact-phone">
                      <span className="flaticon-call"></span>{" "}
                      <a href="tel:+916384003003">6384003003</a>
                    </p>
                    {/* <p className="footer-contact-mail">info@luxuryhotel.com</p> */}
                  </div>
                  <div className="footer-about-social-list">
                    <a href="https://www.instagram.com/gphomes_?igsh=andzdTc2dGVibml6">
                      <i className="ti-instagram fs-4"></i>
                    </a>
                    <a href="https://youtube.com/@gphomes3239?si=AYLrq-oybgtyyovL">
                      <i className="ti-youtube fs-4"></i>
                    </a>
                    <a href="https://www.facebook.com/share/1DMpX1Dzj8/">
                      <i className="ti-facebook fs-4"></i>
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="footer-bottom py-3 bg-dark text-white">
          <Container>
            <Row>
              <Col className="text-center">
                <p className="mb-0 text-white">
                  &copy; {currentYear} GP Homes. All Rights Reserved.
                </p>
              </Col>
            </Row>
          </Container>
        </div>
      </footer>
    </Fragment>
  );
}

export default Footer;
